export default "__VITE_ASSET__xVaDg$35__"